import { gql } from '@apollo/client';

import { Assignment } from '../../types';
import { assignmentFragment } from '../fragments';

export interface GetAssignmentQueryVariables {
  courseId: string;
  assignmentId: string;
}

export interface GetAssignmentQueryResult {
  assignment: Assignment;
}

export const getAssignmentQuery = gql`
  query GetAssignmentQuery($courseId: String!, $assignmentId: String!) {
    assignment(courseId: $courseId, assignmentId: $assignmentId)
      @rest(type: "Assignment", path: "courses/{args.courseId}/assignments/{args.assignmentId}") {
      ...Assignment
    }
  }
  ${assignmentFragment}
`;
